import React, { useEffect, useState } from "react";
import Helmet from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import FadeLoader from "react-spinners/FadeLoader";
import * as Path from "routes/Path/index";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import inputFields from "./inputFields";
import Table from "components/Table";
import Columns from "./Columns";
import { COMMUNITYCATEGORYPAGE } from "common/viewContent";
import { getCategoryListAll, addCategory, ediCategory } from "store/actions";
import CreateCategory from "components/Modals/CreateCategory";

const List = () => {
  const { CATEGORY, categoryLoading, loading, totalCount } = useSelector(
    (state) => state.ChatRoom
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [columns, setcolumns] = useState([{ dataField: "", text: "" }]);
  const [pageSize, setPageSize] = useState(20);
  const [search_text, setSearch_text] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [allCategory, setAllCategory] = useState([]);
  const [editModalShow, setEditModalShow] = useState();
  const [isEdit, setIsEdit] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    image: "",
  });
  const [filter, setFilter] = useState({
    pageNo: currentPage,
    limit: pageSize,
    search_text: "",
  });

  const fetchData = async () => {
    const payload = {
      ...filter,
      page: filter?.pageNo,
      record_count: filter?.limit,
    };
    try {
      const callback = (err, res) => {
        if (err) {
          toast.error(err);
        } else {
          //setDoctor(res);
        }
      };
      dispatch(
        getCategoryListAll({
          data: payload,
          callback,
        })
      );
    } catch (error) {
      console.error(error, "<===err");
    }
  };
  const onClickFilter = (e) => {
    e?.preventDefault();
    setFilter({
      ...filter,
      pageNo: 1,
      limit: pageSize,
      search_text: search_text,
    });
  };
  const clearFilter = () => {
    setFilter((pre) => ({
      ...pre,
      pageNo: 1,
      search_text: "",
      category_id: "",
    }));
    setSearch_text("");
  };
  useEffect(() => {
    fetchData(filter);
    setcolumns(
      Columns({
        currentPage: filter?.pageNo,
        pageSize,
        handleEdithandler,
        handleUserStatus,
      })
    );
  }, [filter]);
  const handleTableChange = (pageNumber, newPageSize) => {
    setCurrentPage(pageNumber);
  };
  const handleEdithandler = (info) => {
    const updatedInfo = {
      ...info,
      bannerImage: info.image,
    };
    setFormData({ ...formData, ...updatedInfo });
    setEditModalShow(true);
    setIsEdit(true);
  };
  const handleCreate = (info) => {
    let data = {
      name: info.name,
      image: info.bannerImage,
      status: info.status || "active",
    };
    if (info.id) {
      data.id = info.id;
    }
    try {
      const callback = (err, res) => {
        if (err) {
          toast.error(err);
          setFormData({
            name: "",
            image: "",
          });
        } else {
          toast.success(res.message);
          fetchData(filter);
          setEditModalShow(false);
          setIsEdit(false);
          setFormData({
            name: "",
            image: "",
          });
        }
      };
      if (data.hasOwnProperty("id")) {
        dispatch(
          ediCategory({
            data: data,
            callback,
          })
        );
      } else {
        dispatch(
          addCategory({
            data: data,
            callback,
          })
        );
      }
    } catch (error) {
      console.error(error, "<===err");
    }
  };
  const handleUserStatus = (row, status) => {
    try {
      const callback = (err, res) => {
        if (err) {
          toast.error(err);
        } else {
          fetchData(filter);
          toast.success("Status Changed");
        }
      };
      dispatch(
        ediCategory({
          data: { id: row?.id, status: status },
          callback,
        })
      );
    } catch (error) {
      console.error(error, "<===err");
    }
  };
  
  return (
    <>
      {categoryLoading && (
        <div className="main-loader">
          <FadeLoader size={1000} />
        </div>
      )}
      {editModalShow && (
        <CreateCategory
          show={editModalShow}
          handleClose={() => {
            setEditModalShow(false);
            setIsEdit(false);
            setFormData({
              name: "",
              image: "",
            });
          }}
          title={isEdit ? "Edit Category" : "Create Category"}
          content={""}
          handleConfirm={handleCreate}
          loading={categoryLoading}
          initialValues={formData}
        />
      )}
      <Helmet title={COMMUNITYCATEGORYPAGE.CURRENT_MODULE} />
      <section className="section">
        <div className="section-header">
          <h1>{COMMUNITYCATEGORYPAGE.CURRENT_MODULE}</h1>
          <div className="section-header-breadcrumb">
            <div className="breadcrumb-item active">
              <Link to={"/admin/" + Path.dashboard}>Dashboard</Link>
            </div>
            <div className="breadcrumb-item">
              {COMMUNITYCATEGORYPAGE.CURRENT_MODULE}{" "}
            </div>
          </div>
        </div>
        <div className="section-body">
          <div className="card">
            <div className="row justify-content-between">
              <div className="col-12">
                <div className="card-header d-flex align-items-center justify-content-between">
                  <h2 className="section-title">
                    {COMMUNITYCATEGORYPAGE.TOP_CONTENT}
                  </h2>
                  <button
                    onClick={() => setEditModalShow(true)}
                    className="d-flex align-items-center justify-content-center btn commonBtn"
                  >
                    Create Category
                  </button>
                </div>
              </div>
              <div className="col-12">
                <form onSubmit={onClickFilter}>
                  <div className="card-header px-3">
                    <div className="row w-100">
                      <div className="col-lg-4 col-sm-12 col-md-12 my-2">
                        <input
                          className="form-control"
                          name="search_text"
                          onChange={(e) => setSearch_text(e.target.value)}
                          value={search_text}
                          placeholder="Search using name..."
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 my-2 gap-4 ">
                    <div className="d-flex gap-4">
                      <button type="submit" className="btn btn-primary btn-lg">
                        Search
                      </button>
                      <button
                        onClick={() => clearFilter()}
                        type="button"
                        className="btn btn-primary btn-lg"
                      >
                        Clear Search
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          {!categoryLoading && CATEGORY?.length > 0 && (
            <Table
              data={CATEGORY}
              columns={columns}
              setFilter={setFilter}
              handleTableChange={handleTableChange}
              totalCount={totalCount}
              filter={filter}
            />
          )}
          {CATEGORY?.length === 0 && (
            <p style={{ textAlign: "center" }}>No Category Found</p>
          )}
        </div>
      </section>
    </>
  );
};
export default List;
